document.addEventListener('DOMContentLoaded', function() {
    /** EU and Hersteller Sizes **/

    const sizesContainer = document.querySelector('._product_variant_sizes');
    if (!sizesContainer) return;

    const variantsSizes = window.variantsSizes || {};
    const productUrl = window.productUrl || '';
    const initSelectedVariant = window.initSelectedVariant || '';

    const str = `<label class="form-field-title">Größe</label>
                <div class="_select-wrapper" id="_product_variant_sizes_select">
                    <div class="_select__inner-wrapper">
                      <div class="_select-value">Lorem ipsum</div>
                      <div class="_select-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 12 8" fill="none">
                            <path d="M1 1.5L6 6.5L11 1.5" stroke="#00334D" stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </div>
                    </div>
        
                    <div class="_select-options">
                      <div class="_select-fixed-options"></div>
                    </div>
              </div>`;

    sizesContainer.innerHTML = str;

    let currUrlVariant = new URL(location.href).searchParams.get('variant') || initSelectedVariant;
    let currColorElem = document.querySelector('[data-option-swatch-value]');
    let currColor = currColorElem ? currColorElem.innerText.trim() : '';

    let sizesOptions = '';
    let currVariantSize = '';

    for (let [id, variantData] of Object.entries(variantsSizes)) {
        if (currColor === variantData.color) {
            let isCurrSize = '';
            if (currUrlVariant === id) {
                isCurrSize = 'selected';
                currVariantSize += `<span>EU: ${variantData.eu}</span> / <span>Hersteller: ${variantData.vendor}</span>`;
            }
            sizesOptions += `<div class="_select-options__item"><a href="${productUrl}?variant=${id}">EU: ${variantData.eu} / Hersteller: ${variantData.vendor}</a></div>`;
        }
    }

    const selectFixedOptions = document.querySelector('._select-fixed-options');
    const selectValue = document.querySelector('._select-value');

    if (selectFixedOptions && selectValue) {
        selectFixedOptions.innerHTML = sizesOptions;
        selectValue.innerHTML = currVariantSize;
    }

    // Select
    const selectDivs = document.querySelectorAll('._select-wrapper');
    selectDivs.forEach(function(sel) {
        sel.addEventListener('click', function(e) {
            if (e.target.closest('._select__inner-wrapper')) {
                const selectOptions = sel.querySelector('._select-options');
                selectOptions.classList.toggle('show-options');
                sel.classList.toggle('open');
            }
        });
    });

    // Mutation Observer для отслеживания изменения URL
    let lastUrl = location.href;
    const observer = new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            onUrlChange();
        }
    });
    observer.observe(document, {subtree: true, childList: true});

    function onUrlChange() {
        let newUrlVariant = new URL(location.href).searchParams.get('variant');
        let newColorElem = document.querySelector('[data-option-swatch-value]');
        let newColor = newColorElem ? newColorElem.innerText.trim() : '';

        let sizesOptions = '';
        let currVariantSize = '';

        for (let [id, variantData] of Object.entries(variantsSizes)) {
            if (newColor === variantData.color) {
                let isCurrSize = '';
                if (newUrlVariant === id) {
                    isCurrSize = 'current';
                    currVariantSize += `<span>EU: ${variantData.eu}</span> / <span>Hersteller: ${variantData.vendor}</span>`;
                }
                sizesOptions += `<div class="_select-options__item"><a href="${productUrl}?variant=${id}">EU: ${variantData.eu} / Hersteller: ${variantData.vendor}</a></div>`;
            }
        }

        if (selectFixedOptions && selectValue) {
            selectFixedOptions.innerHTML = sizesOptions;
            selectValue.innerHTML = currVariantSize;
        }

        setTimeout(function() {
            toggleSizesDisplay();
        }, 800);

        setTimeout(function() {
            toggleSizesDisplay();
        }, 2000);
    }

    function toggleSizesDisplay() {
        const sizesContainer = document.querySelector('._product_variant_sizes');
        const selectFixedOptions = document.querySelector('._select-fixed-options');
        const optionGroesse = document.querySelector('._option-Größe');

        if (sizesContainer && selectFixedOptions) {
            if (sizesContainer.innerHTML === '' || selectFixedOptions.innerHTML === '') {
                sizesContainer.style.display = 'none';
                if (optionGroesse) optionGroesse.style.display = 'block';
            } else {
                sizesContainer.style.display = 'block';
                if (optionGroesse) optionGroesse.style.display = 'none';
            }
        }
    }

    // Инициализация после загрузки
    setTimeout(toggleSizesDisplay, 2000);
    setTimeout(toggleSizesDisplay, 3000);

    // Закрытие опций при клике вне
    document.body.addEventListener('click', function(e) {
        if (!e.target.closest('._select-wrapper')) {
            const allselectOptions = document.querySelectorAll('._select-options');
            allselectOptions.forEach(function(item) {
                item.classList.remove('show-options');
            });
            const sQtywraps = document.querySelectorAll('._select-wrapper');
            sQtywraps.forEach(function(sq) {
                sq.classList.remove('open');
            });
        }
    });
});
